
import { NgbModal,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from "@angular/core";
import { UserModel, UserFilterModel, UserService } from "@bt/core";
import * as $ from 'jquery';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';
//import 'sweetalert2/src/sweetalert2.scss';
import {faExclamationCircle,faTimes} from '@fortawesome/free-solid-svg-icons';


import {  Input } from '@angular/core';

@Component({
  selector: 'delete-users-modal',
  templateUrl:"delete-users.modal.html",
  styleUrls: ["./delete-users.modal.scss"]
})
export class DeleteUserModalContent {
  @Input() isNeedDelete : boolean;
  @Input() description : string;
  faExclamationCircle=faExclamationCircle;
  faTimes=faTimes;
  constructor(public activeModal: NgbActiveModal) {}

  public deleteUsers(){
    this.isNeedDelete=true;
    this.activeModal.close(this.isNeedDelete)
  }
}


// WEBPACK FOOTER //
// ./src/app/admin/all-users/delete-users-modal/delete-users.modal.ts